import Loading from '@/components/Loading';
import PrivateRouter from '@/components/PrivateRouter';
import BMIScreen from '@/screens/BMI';
import Family from '@/screens/Family';
import NotFound from '@/screens/NotFound';
import PHRScreen from '@/screens/PHR';
import useAuth from '@/stores/auth';
import useGlobalConfigs from '@/stores/globalConfigs';
import { PhrStoreProvider } from '@/stores/phr';
import { useQuickModal } from '@/utils/quickModal';
import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import PHRMobile from './screens/PHRMobile';
import { PhrMobileStoreProvider } from './stores/phrMobile';
// import useGlobalMobileConfigs from './stores/globalConfigsMobile';
import PHRMobileScreen from './screens/PHRMobile/PHRMobileScreen';
import PHRMobileDetail from './screens/PHRMobile/PHRMobileDetail';
import PHRMobileLogs from './screens/PHRMobile/PHRMobileLogs';
import PHRMobileMedicalRecords from './screens/PHRMobile/PHRMobileMedicalRecords';
import PHRMobileRecordsByType from './screens/PHRMobile/PHRMobileRecordsByType';
import MedicalRecordsDetail from './screens/PHRMobile/MedicalRecordsDetail';
import MessagingHandle from './components/Layout/MessagingHandle';
import TopBar from '@/components/Layout/TopBar';
import appGlobal from '@/appGlobal';
import useQueries from '@/hooks/useQueries';
function App() {
  console.log('appGlobal.isWebview: ', appGlobal.isWebview);
  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 overscroll-contain">
      <GlobalConfigs />
      <Loading />
      <Routes>
        <Route
          path="/phr/:uid"
          element={
            <PrivateRouter
              roles={['doctor', 'supporter', 'admin']}
              topbar={<TopBar backUrl="/" action />}
              sidebar={<div className="bg-yellow-200 h-[500px] w-[100px]"></div>}
            >
              <PhrStoreProvider>
                <PHRScreen />
                {/* <div className="bg-purple-200 h-full w-full overflow-auto">
                  <div className="bg-green-200 h-[1500px] w-[500px]"></div>
                </div> */}
              </PhrStoreProvider>
            </PrivateRouter>
          }
        />

        <Route
          path="/"
          element={
            <PrivateRouter topbar={<TopBar />} roles={['doctor', 'supporter', 'admin']}>
              <Family />
            </PrivateRouter>
          }
        />

        {/* Custom mobile ui */}
        <Route
          path="/phr-mobile/*"
          // element={<PhrStoreProvider>
          //   <PHRMobileScreen />
          // </PhrStoreProvider>}

          element={
            <PhrMobileStoreProvider>
              <MessagingHandle>
                <PHRMobile />
              </MessagingHandle>
            </PhrMobileStoreProvider>
          }
        >
          <Route index element={<PHRMobileScreen />} />
          <Route path=":uid" element={<PHRMobileScreen />} />
          <Route path="detail/:uid" element={<PHRMobileDetail />} />
          <Route path="medical-records/:uid" element={<PHRMobileMedicalRecords />} />
          <Route path="medical-records/detail/:uid" element={<MedicalRecordsDetail />} />
          <Route path="logs/:uid" element={<PHRMobileLogs />} />
          <Route path="records-by-type/:uid" element={<PHRMobileRecordsByType />} />
          <Route path="*" element={<NotFound />} />
        </Route>

        <Route path="/bmi" element={<BMIScreen />} />

        <Route path="*" element={<NotFound />} />
      </Routes>

      {/* {!appGlobal.isWebview && (
        <div className="rotate-notice">Vui lòng xoay thiết bị của bạn sang chế độ ngang để trải nghiệm tốt hơn.</div>
      )} */}
    </div>
  );
}

export default App;

const GlobalConfigs = () => {
  const getConfigs = useGlobalConfigs((s) => s.getConfigs);
  let token = useAuth((s) => s.token);
  const [queries] = useQueries();
  if (queries.token) {
    token = queries.token;
  }
  //   const getConfigs = useGlobalConfigs((s) => s.getConfigs);
  const { quickModal, quickModalContext } = useQuickModal();
  React.useEffect(() => {
    window.modal = quickModal;
  }, [quickModal]);

  React.useEffect(() => {
    token && getConfigs();
  }, [getConfigs, token]);

  return <>{quickModalContext}</>;
};
